import React from 'react'
import PropTypes from 'prop-types'
import AddMember from '../../inputs/add-member'
import CheckboxInput from '../../inputs/checkbox-input'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import { ajaxGet } from '../../../../ajax'

const Members = ({ hidden, league, member, members, setMember, setMembers, onAlert}) => {
  const canAddPlayer = members.length < league.max_players

  const presentsInTeam = (playerId) => {
    const memberIndex = members.findIndex(m => m.player_id == playerId)
    return memberIndex != -1
  }

  const presentsInLeague = async (playerId) => {
    const response = await ajaxGet(`/admins/leagues/${league.id}/members/${playerId}`)
    const json = await response.json()

    return !!json.member
  }

  const onAddMember = async (data) => {
    if (presentsInTeam(data.player_id)) return onAlert(`Player ${data.name} is already in this team`)
    if (await presentsInLeague(data.player_id)) return onAlert(`Player ${data.name} can only be added once to the same league`)

    setMembers([data, ...members])
    setMember(null)
  }  

  const onDeleteMember = (e, playerId) => {
    e.preventDefault()
    const memberIndex = members.findIndex(m => { return m.player_id == playerId })
    setMembers([
      ...members.slice(0, memberIndex), 
      ...members.slice(memberIndex + 1, memberIndex.length)
    ])
  }

  const onUpdateMember = (playerId, options) => {
    const memberIndex = members.findIndex(m => { return m.player_id == playerId })
    let updatedMember = { ...members[memberIndex], ...options }
    setMembers([
      ...members.slice(0, memberIndex), 
      updatedMember,
      ...members.slice(memberIndex + 1, members.length)
    ])
  }

  const formattedPhone = member => {
    return member.country_code && member.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(member.phone) : formatPhoneNumber(member.phone)
  }

  const membersTable = () => {
    return <table className='members-table'>
      <thead>
        <tr>
          <th>PLAYER</th>
          <th>PHONE</th>
          <th>POSITION</th>
          <th>CAPTAIN</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {membersList()}
      </tbody>
    </table>
  }

  const membersList = () => {
    return members.map((m, i) => {
      return <tr key={i}>
        <td>
          <div className='member-name'>
            <img src={m.image_url || '/images/ic_user@2x.png'} />
            <span>{m.name}</span>
          </div>
        </td>
        <td>{m.phone && formattedPhone(m) || ' '}</td>
        <td>{m.prefer_position}</td>
        <td className='team-captain'>
          <CheckboxInput 
            checked={m.captain}
            name='member-captain'
            onChange={e => onUpdateMember(m.player_id, { captain: e.target.checked })}
          />
        </td>
        <td><button className='delete-member-button' onClick={(e) => onDeleteMember(e, m.player_id)}></button></td>
      </tr>
    })
  }

  return <div className='step-section' hidden={hidden}>
    <div className='section-title'>Add Player</div>
    { canAddPlayer && 
      <AddMember
        disabled={!member}
        openLeague={league.open}
        member={member}
        setMember={setMember}
        onAddMember={onAddMember}
      />
    }
    { !canAddPlayer && 
      <div className='members-limit'>{`The maximum number of players per team for this League is: ${league.max_players}`}</div>
    }
    <div className='members-table-wrap'>
      {membersTable()}
    </div>
  </div>
}

Members.propTypes = {
  hidden: PropTypes.bool.isRequired,
  league: PropTypes.object.isRequired,
  member: PropTypes.object,
  members: PropTypes.array.isRequired,
  setMember: PropTypes.func.isRequired,
  setMembers: PropTypes.func.isRequired,
  onAlert: PropTypes.func.isRequired,
}

export default Members
